// extracted by mini-css-extract-plugin
module.exports = {"StyledContentGallery":"p4wWo","StyledContentGallery_Item":"mI13q","StyledContentGallery_WrapImage":"_1gSo9","StyledContentGallery_Image":"Xc5Dn"};